import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Alert, Button } from 'antd'
import { useCurrentTheme } from '../../../../../hooks/useCurrentTheme'
import { setApplyModified, setNewPreferences } from '../../../../../Redux/slices/Preferences/preferences'
import styles from './Hotkeys.module.scss'
import { getOccurrence, isOnlyUniqueItems } from './utils'
import HotKeysSection from './HotKeysSection'
import { useActions } from '../../../../../hooks/useActions'

const defaultHotkeys = {
	'Board actions': {
		allin: '6',
		check: 'C',
		fold: 'F',
		raise: ['1', '2', '3', '4', '5'],
	},
	'Hand replayer': {
		'Configure a new game': 'D',
		'Full screen mode': 'G',
		'Next hand': 'Enter',
		'Replay hand': 'R',
	},
}

function Hotkeys() {
	const dispatch = useDispatch()
	const settings = useCurrentTheme()
	const disabledButtons = ['raise', 'Next action', 'Next hand', 'Previous action']
	const [isModified, setIsModified] = useState(false)
	const [isApply, setIsApply] = useState(false)
	const { resetHotkeys } = useActions()

	const [isDoubleKeys, setIsDoubleKeys] = useState('')

	const currentValues = Object.values(settings.hotkeys['Board actions'])
		.filter((value) => !Array.isArray(value))
		.concat(settings.hotkeys['Board actions'].raise, Object.values(settings.hotkeys['Hand replayer']))
		.map((value) => value.toUpperCase())

	const isDouble = (value, setIsDoubleKeys) => {
		const isDouble = getOccurrence(currentValues, value) > 1

		if (isDouble) {
			setIsDoubleKeys(value)
		}

		if (!isDouble && value === isDoubleKeys) {
			setIsDoubleKeys('')
		}

		return isDouble ? styles.double : styles.single
	}

	const handlePressKey = (key, button, hotkeysGroup) => {
		const pressedButton = button
			.split(/(?=[A-Z])/)
			.join(' ')
			.toUpperCase()

		dispatch(setNewPreferences(key, pressedButton, 'hotkeys', `${hotkeysGroup}`))
		setIsModified(true)
	}

	useEffect(() => {
		isModified && setIsApply(isOnlyUniqueItems(currentValues))
	}, [isModified, currentValues])

	useEffect(() => {
		dispatch(setApplyModified(isApply))
	}, [isApply])

	return (
		<div className={styles.hotKeysWrapper}>
			<div>
				{Object.entries(settings.hotkeys).map(([title, rows]) => {
					return (
						<HotKeysSection
							title={title}
							rows={rows}
							key={title}
							handlePressKey={handlePressKey}
							isDouble={isDouble}
							disabledButtons={disabledButtons}
							setIsDoubleKeys={setIsDoubleKeys}
						/>
					)
				})}
			</div>

			<div>
				{isDoubleKeys ? (
					<Alert
						message='More than one key is assigned'
						description='You cannot use the same key for two commands, please change the key assignment'
						type='error'
						showIcon
					/>
				) : null}

				<Button size='small' onClick={() => resetHotkeys(defaultHotkeys)}>
					Reset to default
				</Button>
			</div>
		</div>
	)
}

export default Hotkeys
